import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { UI_ROUTES } from 'src/app/app.contant';
import { SupplierService } from 'src/app/modules/supplier/services/supplier.service';

@Component({
  selector: 'app-open-onboard-modal',
  templateUrl: './open-onboard-modal.component.html',
  styleUrls: ['./open-onboard-modal.component.scss']
})
export class OpenOnboardModalComponent implements OnInit {

  public statusForm!: FormGroup;
  public vendor_code:any;
  public rfq_template_id:any;
  public puchase_org:any;
  public prData: any;
  public onClose = new Subject<any>();
  public readonly ROUTES = UI_ROUTES;

  constructor(
    public bsModalRef: BsModalRef,
    private _supplierService : SupplierService,
    private _router: Router,
    private _toastrService : ToastrService,
    private _formBuilder: FormBuilder) {
      this.statusForm = this._formBuilder.group({
        rfq_template_id : '',
        puchase_org : [null, [Validators.required]],
        vendor_code : [null, [Validators.required]]
      });
   }

  ngOnInit(): void {
    this.rfq_template_id = this.prData.rfq_template_id? this.prData.rfq_template_id:this.prData.quotations[0].rfq_template_id.id;
  }

  public submit(){
    const payload = {
      rfq_template_id: this.rfq_template_id,
      vendor_code: this.vendor_code,
      purchase_organization: this.puchase_org
    }
    console.log("payload",payload)
    this._supplierService.openOnboard(payload).subscribe((res:any)=>{
      if(res.status == 200){
        this._toastrService.success("Onboard Successfull")
        this._router.navigateByUrl(this.ROUTES.HOME)
      }
    })
    this.bsModalRef.hide()
  }

}
